module.exports = __webpack_public_path__ + "static/media/double-arrow-down-icon.119d2730.svg";